<template>
  <!-- <div v-if="dialogVisible"> -->
  <el-dialog class="custom-dialog-data" :close-on-click-modal="false" :show-close="false" center :visible.sync="dialogVisible" width="40%"
    :before-close="handleClose">
    <!-- <div id='aaaa'> -->
    <el-dialog width="38%" class="custom-dialog-inner-data" center :title="innerTitle" :visible.sync="innerVisible"
      :before-close="handleInnerClose" append-to-body>
      <slot name="dialogInner" class="dialog-inner"></slot>
    </el-dialog>
    <div slot="title" v-if="title" class="header-title">
      <div class="dialog-name">
        <div class="text">{{title || ''}}</div>
      </div>
      <slot name="dialogTitleCenter"></slot>
    </div>
    <img @click="handleClose" v-if="isShowCloseIcon" src="@/assets/img/icon-delete.png" class="dialog-close-icon"
      alt="">
    <slot name="dialogBody"></slot>
    <!-- </div> -->
    <div slot="footer" class="dialog-footer">
      <slot name="dialogFooter"></slot>
    </div>
  </el-dialog>
  <!-- </div> -->
</template>

<script>
  export default {
    props: {
      dialogVisible: {
        type: Boolean,
        default: false
      },
      innerVisible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ''
      },
      innerTitle: {
        type: String,
        default: ''
      },
      isShowCloseIcon: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
      }
    },
    mounted() { },
    methods: {
      handleClose() {
        this.$emit("handleClose");
      },
      handleInnerClose() {
        this.$emit("handleInnerClose");
      },
    },
  };
</script>

<style scoped lang="scss">
  .custom-dialog-data {
    >>>.el-dialog {
      margin-top: 8vh !important;
      height: 85vh;
      display: flex;
      flex-direction: column;
      padding: 0 20px;
      padding-bottom: 6px;
    }

    >>>.el-dialog__header {
      padding: 0;

      .header-title {
        margin-bottom: 14px;

        .dialog-name {
          height: 56px;
          line-height: 56px;

          font-size: 16px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          position: relative;

          .text {
            font-size: 16px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
          }
        }
      }
    }

    .dialog-close-icon {
      position: absolute;
      width: 16px;
      height: 16px;
      cursor: pointer;
      right: 20px;
      top: 20px;
      z-index: 1;
    }

    >>>.el-dialog__body {
      padding: 0;
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      display: flex;
      flex-direction: column;
    }

    >>>.el-dialog__footer {
      padding: 0;
    }
  }

  .custom-dialog-inner-data {
    >>>.el-dialog {
      margin-top: 8vh !important;
      height: 85vh;
      display: flex;
      flex-direction: column;
    }

    >>>.el-dialog__body {
      padding: 0 20px;
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      display: flex;
      flex-direction: column;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/vueDialog.vue